import { createTheme } from '@mui/material/styles';

// Visual do painel (redesign 2026): navy sólido, cantos de 6–10px, bordas
// finas no lugar de sombras, tipografia Public Sans.
const NAVY = '#0b2a45';
const NAVY_CLARO = '#123a5c';
const BORDA = '#e2e6ec';
const TEXTO = '#14212e';

const theme = createTheme({
  palette: {
    primary: {
      main: NAVY_CLARO,
      light: '#1d4b73',
      dark: NAVY,
      contrastText: '#fff',
    },
    secondary: {
      main: '#c0392b',
    },
    success: { main: '#1f8a4c' },
    warning: { main: '#d99a1a' },
    error: { main: '#c0392b' },
    text: {
      primary: TEXTO,
      secondary: '#5c6b7a',
    },
    divider: BORDA,
    background: {
      default: '#f1f3f6',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: '"Public Sans", "Segoe UI", "Helvetica", "Arial", sans-serif',
    fontSize: 13,
    h4: { fontWeight: 800 },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 700 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  shape: {
    borderRadius: 6,
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          borderRadius: 6,
          fontWeight: 600,
          fontSize: 13,
          boxShadow: 'none',
          '&:hover': { boxShadow: 'none' },
        },
        sizeLarge: {
          fontSize: 14,
          paddingTop: 10,
          paddingBottom: 10,
        },
        containedPrimary: {
          backgroundColor: NAVY_CLARO,
          '&:hover': { backgroundColor: NAVY },
        },
        outlined: {
          borderColor: BORDA,
          color: TEXTO,
          backgroundColor: '#fff',
          '&:hover': { borderColor: '#cfd6df', backgroundColor: '#f6f8fa' },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 10,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          backgroundColor: '#fff',
          '& .MuiOutlinedInput-notchedOutline': { borderColor: BORDA },
          '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#c8d0da' },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: NAVY_CLARO,
            borderWidth: 1.5,
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          '&.Mui-focused': { color: NAVY_CLARO },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          borderRadius: 6,
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: '#9aa6b2',
          '&.Mui-checked': { color: NAVY_CLARO },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottomColor: BORDA,
        },
        head: {
          fontWeight: 700,
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          fontSize: 13,
        },
        standardSuccess: { backgroundColor: '#e6f4ec', color: '#14532d' },
        standardError: { backgroundColor: '#fdecea', color: '#7f1d1d' },
        standardWarning: { backgroundColor: '#fdf3dc', color: '#6b4a00' },
        standardInfo: { backgroundColor: '#e8f0f8', color: NAVY },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 12,
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: NAVY,
          fontSize: 11.5,
        },
      },
    },
  },
});

export default theme;
